module.exports = __webpack_public_path__ + "img/Spectra Icon_Over.8fa5ebbb.svg";